import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import './translation';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
// eslint-disable-next-line sort-imports
import { BrowserRouter } from 'react-router-dom';

import { store } from './app/store';
import reportWebVitals from './reportWebVitals';
// eslint-disable-next-line sort-imports
import AppRoutes from './routes';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
